import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { COMPANY, CompanyName } from 'config'
import { Button } from 'components/Button/Button'
import style from './LanguageSwitcher.module.css'

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  // Закрываем выпадающий список при клике вне его
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  if (COMPANY !== CompanyName.SKYEER) {
    return null
  }

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng)
    localStorage.setItem('language', lng)
    setIsOpen(false)
  }

  const currentLanguage = i18n.language
  const currentLanguageUpper = currentLanguage?.toUpperCase() || 'RU'

  const languages = [
    { code: 'ru', label: 'Русский' },
    { code: 'en', label: 'English' },
  ]

  return (
    <div className={style.languageSwitcher} ref={dropdownRef}>
      <Button.Outlined className={style.button} onClick={() => setIsOpen(!isOpen)} type="button">
        <span className={style.currentLang}>{currentLanguageUpper}</span>
      </Button.Outlined>

      {isOpen && (
        <div className={style.dropdown}>
          {languages.map(lang => (
            <div
              key={lang.code}
              className={`${style.dropdownItem} ${currentLanguage === lang.code ? style.active : ''}`}
              onClick={() => changeLanguage(lang.code)}
            >
              {lang.label}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default LanguageSwitcher
